import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { joinWithSeparator } from '../../../../../utils/formater';

// TODO добавить метро

function RealtyType (props) {
  const isMultiLocality = props.domain.get('isMultiLocality');
  const item = props.item;
  const property = item.getProperty();
  const type = property.getType();

  const geoLocation = property.getGeoLocation();
  const locality = geoLocation.getLocality();
  const regionDistrict = geoLocation.getRegionDistrict();
  const localityDistrict = geoLocation.getLocalityDistrict();
  const localityMicrodistrict = geoLocation.getLocalityMicrodistrict();

  const dataSource = item.getDataSource();
  const viewDataSource = props.user.getIn(['data', 'permissions', 'viewDataSource']);

  return (
    <td className='col-realty-type'>
      { type && (<span className='main-param'>{type.get('middleName')}</span>) }
      <br />

      {isMultiLocality && locality && (<div>{locality.name}</div>)}

      { geoLocation.isSuburb() && 'область' }

      {
        geoLocation.isSuburb()
          ? (regionDistrict && (<div>{regionDistrict.shortName.toLowerCase()}</div>))
          : (
            <Fragment>
              <div>{ localityDistrict && localityDistrict.shortName.toLowerCase() }</div>
              <div>{ localityMicrodistrict && localityMicrodistrict.shortName }</div>
            </Fragment>
          )
      }

      { viewDataSource && dataSource && dataSource.getApplication() && (<div className='source-data'>{dataSource.getApplication().get('fullName')}</div>) }
      { viewDataSource && dataSource && dataSource.getFeed() && (<div className='source-data'>xml</div>) }
      { viewDataSource && dataSource && dataSource.getCianSource() && (<div className='source-data'>{dataSource.getCianSource().get('fullName')}</div>) }
    </td>
  );
}

RealtyType.propTypes = {
  user: PropTypes.object.isRequired,
  domain: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired
};

RealtyType.defaultProps = {};

export default RealtyType;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/RealtyType.jsx